import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPlaces } from './placesThunk';
import { Place, PlacesState } from './types';
import { CustomError } from 'shared/api';

const initialState: PlacesState = {
	places: [],
	loading: true,
	error: null,
};

export const placesSlice = createSlice({
	name: 'places',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(getPlaces.pending, state => {
				state.loading = true;
			})
			.addCase(
				getPlaces.fulfilled,
				(state, action: PayloadAction<Place[]>) => {
					state.loading = false;
					const places = action.payload;
					if (places) {
						state.places = places.sort((a, b) => a.id - b.id);
					}
				},
			)
			.addCase(getPlaces.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as CustomError;
			});
	},
});

export const placesReducer = placesSlice.reducer;
